import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { Tabs } from "src/app/common/tabs/tabs.enum";
import { TabsService } from "src/app/common/tabs/tabs.service";
import { ModalService } from "src/app/services/modal.service";
import { TilgangService } from "src/app/services/tilgang.service";
import { TabSideBaseClass } from "../../common/tab-side/tab-side.component";
import { DatabaseSystem, KoblingerService } from "../../koblinger/koblinger.service";
import { throwError } from "rxjs";


@Component({
  selector: "app-itsystemtjenester-tab",
  templateUrl: "./itsystemdatabase-tab.component.html"

})
export class ItsystemDatabaseTabComponent extends TabSideBaseClass<DatabaseSystem> {

  tabName(): Tabs {
    return Tabs.database;
  }

  constructor(tabsService: TabsService, service: KoblingerService, tilgangService: TilgangService, modal: ModalService, route: ActivatedRoute, router: Router) {
    super(tabsService, service, tilgangService, modal, route, router);
  }

  loaderObservable(service: KoblingerService, id: number): Observable<DatabaseSystem[]> {
    return this.service.getDatabaseSystemForSystem(id);
  }

  pageLinkAccess(service: TilgangService): Observable<boolean> {
    return of(true);
  }

  removeObservable(service: KoblingerService, item: DatabaseSystem): Observable<object> {
    // Kommentert ut 16.april 2026. Skal ikke ha denne funksjonaliteten her lenger.
    //return service.removeDatabaseSystemForSystem(item.databaseId, item.systemId);
    return throwError(() => new Error('removeObservable er avviklet'));
  }


  kobleTil(): void {
    /*
    // Kommentert ut 16.april 2026. Skal ikke ha denne funksjonaliteten her lenger.
    this.modal.velgDatabase().then(database => {

      if (this.liste.some(t => t.databaseId === database.databaseId)) {
        this.modal.warning(`${database.navn} er allerede koblet til system`, "Kobling feilet");
        return;
      }

      const item: DatabaseSystem = { systemId: this.id, databaseId: database.databaseId, type : database.type };


      this.service.postDatabaseSystemForSystem(item).toPromise().then(() => {
        this.modal.success("", "Database koblet til system");
        this.load();
      });
    });
    */
  }




}
